import { Controller } from '@hotwired/stimulus'
// @ts-expect-error: el-transition is not typed
import { enter, leave } from 'el-transition'

// Connects to data-controller='new-member-form'
export default class extends Controller {
  static targets = [
    'backdrop',
    'body',
    'memberForm',
    'smsAccountNotificationOptInCheckbox',
    'smsAiOptInCheckbox',
    'smsConfirmModal',
    'submitButton',
    'continueWithoutSmsButton'
  ]

  declare readonly backdropTarget: HTMLElement
  declare readonly bodyTarget: HTMLElement
  declare readonly memberFormTarget: HTMLFormElement
  declare readonly hasSmsAccountNotificationOptInCheckboxTarget: boolean
  declare readonly hasSmsAiOptInCheckboxTarget: boolean
  declare readonly smsAccountNotificationOptInCheckboxTarget: HTMLInputElement
  declare readonly smsAiOptInCheckboxTarget: HTMLInputElement
  declare readonly smsConfirmModalTarget: HTMLDialogElement
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly continueWithoutSmsButtonTarget: HTMLButtonElement

  submitForm (): void {
    if (!this.hasSmsAccountNotificationOptInCheckboxTarget && !this.hasSmsAiOptInCheckboxTarget) {
      this.submitButtonTarget.disabled = true
      this.memberFormTarget.submit()
    } else if (this.smsAiOptInCheckboxTarget.checked && this.smsAccountNotificationOptInCheckboxTarget.checked) {
      this.submitButtonTarget.disabled = true
      this.memberFormTarget.submit()
    } else {
      Promise.all([enter(this.smsConfirmModalTarget), enter(this.bodyTarget)]).then(() => {
        this.smsConfirmModalTarget.showModal()
      })
    }
  }

  continue (): boolean {
    this.continueWithoutSmsButtonTarget.disabled = true
    this.memberFormTarget.submit()
    return false
  }

  back (): void {
    Promise.all([leave(this.smsConfirmModalTarget), leave(this.bodyTarget)]).then(() => {
      this.smsConfirmModalTarget.close()
    })
  }
}
